import React, { useState } from "react";
import { Container, Col, Row, FormGroup, Modal } from "react-bootstrap";
import {
  MdNavigateNext,
  MdNavigateBefore,
  MdAdd,
  MdClose,
} from "react-icons/md";
import FormValidator from "../../../../../shared/utils/FormValidator";
import { useStorage, useFunctions } from "reactfire";
import BarLoader from "react-spinners/BarLoader";
import Guidelines from "../../guidelines/Guidelines";
import randomString from "randomstring";
import AppFormCheck from "../../app-form-check/AppFormCheck";
import { AiOutlineFilePdf } from "react-icons/ai";
import { Country, TeamRole } from "../../../../../shared/constants/Constant";
import Application from "../../../../../database/models/application-form/bosnia/Application";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";
import Alert from "../../../../../shared/components/alert/Alert";

// SidePanel

interface IState {
  isAgree: boolean;
  isAgreeError: string;
  fullName: string;
  fullNameError: string;
  dob: Date;
  dobError: string;
  email: string;
  emailError: string;
  contact: string;
  contactError: string;
  placeOfResidence: string;
  placeOfResidenceError: string;
  whoYouAre: string;
  whoYouAreError: string;
  whatYouAreStudying: string;
  whatYouAreStudyingError: string;

  cv: any;
  cvError: string;
  motivation: string;
  motivationError: string;
  commitment: string;
  commitmentError: string;
  pastExperience: string;
  pastExperienceError: string;
  formStage: "SECTION_A" | "SECTION_B";
  loading: boolean;
  showGuidelines: boolean;
  hasError: boolean;
}

const initialState: IState = {
  isAgree: false,
  isAgreeError: "",
  fullName: "",
  fullNameError: "",
  email: "",
  emailError: "",
  dob: new Date(),
  dobError: "",
  contact: "",
  contactError: "",
  placeOfResidence: "",
  placeOfResidenceError: "",
  whoYouAre: "Undergraduate student",
  whoYouAreError: "",
  whatYouAreStudying: "",
  whatYouAreStudyingError: "",
  cv: null,
  cvError: "",
  motivation: "",
  motivationError: "",
  commitment: "",
  commitmentError: "",
  pastExperience: "",
  pastExperienceError: "",
  formStage: "SECTION_A",
  loading: false,
  showGuidelines: true,
  hasError: false,
};

interface IProps {
  onComplete(application: Application, fileName: string): void;
}

const ApplicationFormBosnia = (props: IProps) => {
  const [state, setState] = useState(initialState);
  const [other, setOther] = useState({ value: "", checked: false, error: "" });
  const initialUploader: any = null;
  const [uploader, setUploader] = useState(initialUploader);
  const [upFileName, setUpFileName] = useState("");

  const validateSectionA = (): boolean => {
    const fnValidation = FormValidator.validateString(
      state.fullName,
      "Full Name",
      3,
      100
    );
    const aggValidation = state.isAgree
      ? {
          message: "",
          isValid: true,
        }
      : {
          message:
            "Please click 'Yes' after reading the competition rules and guidelines to be able to submit the application",
          isValid: false,
        };
    const emailValidation = FormValidator.validateEmail(state.email);

    const porValidation = FormValidator.validateString(
      state.placeOfResidence,
      "The answer",
      3,
      100
    );

    const conValidation = FormValidator.validateString(
      state.contact,
      "Contact Number",
      -1,
      13
    );

    const wyaValidation =
      state.whoYouAre === "Other"
        ? FormValidator.validateString(other.value, "The Answer", 3, 100)
        : state.whoYouAre === "Undegraduate student" ||
          state.whoYouAre === "Master student" ||
          state.whoYouAre === "PhD student" ||
          state.whoYouAre === "Unemployed (non student)" ||
          state.whoYouAre === "Employed (non student)"
        ? {
            message: "",
            isValid: true,
          }
        : {
            message: "Invalid Answer",
            isValid: false,
          };

    const stdyValidation = FormValidator.validateString(
      state.whatYouAreStudying,
      "The answer",
      3,
      1500
    );

    const dobValidation = FormValidator.validateDob(state.dob, "Date of birth");

    setState({
      ...state,
      fullNameError: fnValidation.message,
      dobError: dobValidation.message,
      isAgreeError: aggValidation.message,
      placeOfResidenceError: porValidation.message,
      whoYouAreError: wyaValidation.message,
      emailError: emailValidation.message,
      whatYouAreStudyingError: stdyValidation.message,
      contactError: conValidation.message,
    });

    return (
      fnValidation.isValid &&
      dobValidation.isValid &&
      aggValidation.isValid &&
      porValidation.isValid &&
      wyaValidation.isValid &&
      stdyValidation.isValid &&
      emailValidation.isValid &&
      conValidation.isValid
    );
  };

  const validateSectionB = (): boolean => {
    const motivationValidation = FormValidator.validateString(
      state.motivation,
      "The answer",
      3,
      1500
    );
    const commitmentValidation = FormValidator.validateString(
      state.commitment,
      "The answer",
      3,
      1500
    );
    const peValidation = FormValidator.validateString(
      state.pastExperience,
      "The answer",
      3,
      1500
    );
    const fileValidation =
      state.cv === null
        ? { message: "CV/Resume is required.", isValid: false }
        : state.cv?.type !== "application/pdf"
        ? { message: "Only pdf files are allowed.", isValid: false }
        : state.cv.size > 105255200
        ? {
            message: "File size cannot be more than 100MB",
            isValid: false,
          }
        : { message: "", isValid: true };
    setState({
      ...state,
      motivationError: motivationValidation.message,
      commitmentError: commitmentValidation.message,
      cvError: fileValidation.message,
      pastExperienceError: peValidation.message,
    });
    return (
      motivationValidation.isValid &&
      commitmentValidation.isValid &&
      fileValidation.isValid &&
      peValidation.isValid
    );
  };

  const applicationRef = useFunctions().httpsCallable(
    "submitApplicationBosnia"
  );
  const storageRef = useStorage().ref();
  // const [uploadPrograss, setUploadProgress] = useState(0);

  const validateAllData = (): boolean => {
    const a = validateSectionA();
    const b = validateSectionB();
    if (a && b) {
      return true;
    } else {
      setTimeout(() => {
        document
          .getElementsByClassName("invalid")
          .item(0)
          ?.parentElement?.scrollIntoView({
            behavior: "smooth",
          });
      }, 100);
      return false;
    }
  };

  const submitForm = () => {
    setState((ps) => ({ ...ps, loading: true }));
    const file: any = state.cv;
    const uploadTask = storageRef.child(`resumes/${state.cv?.name}`).put(file);
    uploadTask.on(
      "state_changed",
      (snap) => {},
      (err) => {},
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((url) => {
          const applicationData: any = {
            members: [
              {
                fullName: state.fullName,
                email: state.email,
                dob: state.dob.toDateString(),
                contact: state.contact,
                status: other.checked ? other.value : state.whoYouAre,
                residence: state.placeOfResidence,
                studying: state.whatYouAreStudying,
                commitment: state.commitment,
                motivation: state.motivation,
                pastExperience: state.pastExperience,
                cvLink: url,
                role: TeamRole.LEADER,
                country: Country.BOSNIA,
              },
            ],
            country: Country.BOSNIA,
          };
          applicationRef(applicationData)
            .then((data) => {
              setState({ ...initialState });

              const fileName = `${upFileName}`;
              setUpFileName("");
              props.onComplete(
                {
                  fullName: state.fullName,
                  email: state.email,
                  dob: state.dob,
                  contact: state.contact,
                  whoYouAre: other.checked ? other.value : state.whoYouAre,
                  country: Country.BOSNIA,
                  placeOfResidence: state.placeOfResidence,
                  whatYouAreStudying: state.whatYouAreStudying,
                  cvLink: url,
                  commitment: state.commitment,
                  motivation: state.motivation,
                  pastExperience: state.pastExperience,
                },
                fileName
              );
            })
            .catch((err) => {
              storageRef
                .child(`resumes/${state.cv?.name}`)
                .delete()
                .then(() => {
                  //doto - handle this
                })
                .catch(() => {
                  //doto - handle this
                })
                .finally(() => {
                  setState({ ...state, loading: false, hasError: true });
                  setShow(false);
                });
            })
            .finally(() => {});
        });
      }
    );
  };

  const formSectionA = () => {
    return (
      <div>
        <FormGroup>
          <label className="font-weight-bold form-label">
            I have read, understood, and agree to the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://in.ieee.org/guidelines-bih"
            >
              competition rules and guidelines
            </a>
          </label>
          <fieldset id="group5">
            <div className="form-check">
              <input
                type="radio"
                checked={state.isAgree}
                name="group5"
                className="form-check-input"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    isAgree: e.target.checked,
                    isAgreeError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) => setState({ ...state, isAgree: true })}
              >
                Yes
              </label>
            </div>
            <div className="form-check">
              <input
                type="radio"
                checked={!state.isAgree}
                className="form-check-input"
                name="group5"
                onChange={(e: any) =>
                  setState({ ...state, isAgree: !e.target.checked })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) => setState({ ...state, isAgree: false })}
              >
                No
              </label>
            </div>
          </fieldset>
          <label className="error-message">{state.isAgreeError}</label>
          <input
            className={
              state.isAgreeError.length < 1 ? "d-none" : "d-none invalid"
            }
          />
        </FormGroup>
        <FormGroup>
          <label
            className="font-weight-bold form-label"
            style={{ fontSize: "larger" }}
          >
            Personal Information
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Full Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.fullNameError.length < 1 ? "app-input" : "app-input invalid"
            }
            placeholder="Full Name"
            value={state.fullName}
            onChange={(e) => {
              setState({
                ...state,
                fullName: e.target.value,
                fullNameError: "",
              });
            }}
          />
          <label className="error-message">{state.fullNameError}</label>
        </FormGroup>
        <FormGroup style={{ height: "102px" }}>
          <label className="font-weight-bold form-label">
            Date of birth
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <br />
          <DatePicker
            className={
              state.dobError.length < 1 ? "app-input" : "app-input invalid"
            }
            selected={
              state.dob.toDateString() !== new Date().toDateString()
                ? state.dob
                : null
            }
            onChange={(date: Date) => {
              setState({ ...state, dob: date, dobError: "" });
            }}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            placeholderText="mm/dd/yyyy"
            popperPlacement="top-end"
            dropdownMode="select"
            customInput={<input className="app-input" />}
          />
          <br />
          <label className="error-message">{state.dobError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Email Address
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.emailError.length < 1 ? "app-input" : "app-input invalid"
            }
            placeholder="Email Address"
            value={state.email}
            onChange={(e) => {
              setState({
                ...state,
                email: e.target.value,
                emailError: "",
              });
            }}
          />
          <label className="error-message">{state.emailError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Phone Number
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.contactError.length < 1 ? "app-input" : "app-input invalid"
            }
            value={state.contact}
            placeholder="Phone Number"
            onChange={(e) => {
              setState({
                ...state,
                contact: e.target.value,
                contactError: "",
              });
            }}
          />
          <label className="error-message">{state.contactError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Current place of residence (example: Tuzla, Banja Luka, Sarajevo
            etc)
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.placeOfResidenceError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.placeOfResidence}
            placeholder="Your answer"
            onChange={(e) => {
              setState({
                ...state,
                placeOfResidence: e.target.value,
                placeOfResidenceError: "",
              });
            }}
          />
          <label className="error-message">{state.placeOfResidenceError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Who are you?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <AppFormCheck
            type="radio"
            label="Undergraduate student"
            value="Undergraduate student"
            checked={state.whoYouAre === "Undergraduate student"}
            onChange={(e: any) => {
              setState({
                ...state,
                whoYouAre: "Undergraduate student",
                whoYouAreError: "",
              });
              setOther({ ...other, checked: false });
            }}
          />
          <AppFormCheck
            type="radio"
            label="Master student"
            value="Master student"
            checked={state.whoYouAre === "Master student"}
            onChange={(e: any) => {
              setState({
                ...state,
                whoYouAre: "Master student",
                whoYouAreError: "",
              });
              setOther({ ...other, checked: false });
            }}
          />
          <AppFormCheck
            type="radio"
            label="PhD student"
            value="PhD student"
            checked={state.whoYouAre === "PhD student"}
            onChange={(e: any) => {
              setState({
                ...state,
                whoYouAre: "PhD student",
                whoYouAreError: "",
              });
              setOther({ ...other, checked: false });
            }}
          />
          <AppFormCheck
            type="radio"
            label="Unemployed (non student)"
            value="Unemployed (non student)"
            checked={state.whoYouAre === "Unemployed (non student)"}
            onChange={(e: any) => {
              setState({
                ...state,
                whoYouAre: "Unemployed (non student)",
                whoYouAreError: "",
              });
              setOther({ ...other, checked: false });
            }}
          />
          <AppFormCheck
            type="radio"
            label="Employed (non student)"
            value="Employed (non student)"
            checked={state.whoYouAre === "Employed (non student)"}
            onChange={(e: any) => {
              setState({
                ...state,
                whoYouAre: "Employed (non student)",
                whoYouAreError: "",
              });
              setOther({ ...other, checked: false });
            }}
          />
          <AppFormCheck
            type="radio"
            label="Other"
            value="Other"
            checked={state.whoYouAre === "Other"}
            onChange={(checked) => {
              setState({ ...state, whoYouAre: "Other", whoYouAreError: "" });
              setOther({ ...other, checked: true });
            }}
          />

          {other.checked && (
            <input
              className="app-input"
              value={other.value}
              onChange={(e) => setOther({ ...other, value: e.target.value })}
            />
          )}

          <label className="error-message">{state.whoYouAreError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            What are you studying and/or where are you employed? (If student -
            please list what you are studying currently ex. computer science,
            marketing), <br />
            If you work in a company please list it)
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <textarea
            className={
              state.placeOfResidenceError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.whatYouAreStudying}
            placeholder="Your answer"
            onChange={(e) => {
              setState({
                ...state,
                whatYouAreStudying: e.target.value,
                whatYouAreStudyingError: "",
              });
            }}
          />
          <label className="error-message">
            {state.whatYouAreStudyingError}
          </label>
        </FormGroup>
      </div>
    );
  };

  const formSectionB = () => {
    return (
      <div>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Please upload a detailed CV/Resume
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <br />
          {state.cvError.length > 0 && (
            <input className="app-input invalid d-none" />
          )}
          <input
            className="d-none"
            type="file"
            accept=".pdf"
            ref={(ref) => setUploader(ref)}
            onChange={(e) => {
              const file = e.target.files && e.target.files[0];
              if (file !== null) {
                setUpFileName(file?.name);
                const blob = file?.slice(0, file.size, file?.type);
                const newFile = new File(
                  [blob],
                  `${randomString.generate()}.${file?.name.split(".").pop()}`,
                  { type: file?.type }
                );
                if (file?.type !== "application/pdf") {
                  setState({
                    ...state,
                    cv: newFile,
                    cvError: "Only pdf files are allowed.",
                  });
                } else if (file?.size > 105255200) {
                  setState({
                    ...state,
                    cv: newFile,
                    cvError: "File size cannot be more than 100MB",
                  });
                } else {
                  setState({ ...state, cv: newFile, cvError: "" });
                }
              }
              e.target.value = "";
            }}
          />
          {upFileName.length > 0 ? (
            <div className="uploaded-file animated fadeIn">
              <span>
                <AiOutlineFilePdf />
              </span>
              <span className="mx-2">{upFileName}</span>
              <span className="remove-file">
                <MdClose
                  onClick={() => {
                    setUpFileName("");
                    setState({ ...state, cv: null, cvError: "" });
                  }}
                />
              </span>
            </div>
          ) : (
            <button className="app-button" onClick={() => uploader.click()}>
              <span className="mr-2">
                <MdAdd style={{ transform: "scale(1.5) translateY(-2px)" }} />
              </span>
              Attach File
            </button>
          )}
          <br />
          <label className="error-message">{state.cvError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Key selection criteria
          </label>
        </FormGroup>
        <FormGroup className="sectionb-infor-message">
          <p>
            Ultimately, we are looking for highly committed and motivated young
            people who are willing to invest their time into unparalleled
            quality education that will enable them to launch their careers to
            new heights.
          </p>
          <p className="im-title">There are 3 key selection criteria:</p>
          <ol>
            <li>
              Motivation (50%) - how motivated are you to develop innovative
              ideas and become an entrepreneur?
            </li>
            <li>
              Commitment (30%) - how capable are you of combining the program
              activities with your regular responsibilities?
            </li>
            <li>
              Past Experiences (20%) - this does not only relate to
              innovation/entrepreneurship, but your general past experiences
              (technical projects, business ideas, hackathons etc.).
            </li>
          </ol>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Motivation - What is your motivation to want to participate in the
            program and what do you hope to achieve?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <textarea
            className={
              state.motivationError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.motivation}
            onChange={(e) => {
              setState({
                ...state,
                motivation: e.target.value,
                motivationError: "",
              });
            }}
          />
          <label className="error-message">{state.motivationError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Commitment - This program will require you to invest at least 10
            hours per week in it. What makes you believe you are committed to
            completing the program?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <textarea
            className={
              state.commitmentError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.commitment}
            onChange={(e) => {
              setState({
                ...state,
                commitment: e.target.value,
                commitmentError: "",
              });
            }}
          />
          <label className="error-message">{state.commitmentError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Past experience - What past experiences do you have that make you a
            good candidate for a scholarship in this program?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <textarea
            className={
              state.pastExperienceError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.pastExperience}
            onChange={(e) => {
              setState({
                ...state,
                pastExperience: e.target.value,
                pastExperienceError: "",
              });
            }}
          />
          <label className="error-message">{state.pastExperienceError}</label>
        </FormGroup>
      </div>
    );
  };

  const [show, setShow] = useState(false);

  return (
    <Container fluid>
      <Row className="p-md-5">
        <Col xs={12}>
          <form
            onSubmit={(e: any) => {
              e.preventDefault();
            }}
          >
            {state.formStage === "SECTION_A" ? formSectionA() : formSectionB()}{" "}
            {state.hasError && (
              <FormGroup
                style={{ marginTop: "30px" }}
                className="d-flex justify-content-end"
              >
                <div style={{ width: "300px" }}>
                  <Alert
                    show={state.hasError}
                    onClose={() => setState({ ...state, hasError: false })}
                  >
                    Application submission failed
                  </Alert>
                </div>
              </FormGroup>
            )}
            <FormGroup className="text-right">
              {state.formStage === "SECTION_B" && !state.loading && (
                <button
                  className="mr-1 app-button"
                  onClick={() => {
                    setState({ ...state, formStage: "SECTION_A" });
                  }}
                >
                  <span className="mr-2">
                    <MdNavigateBefore
                      style={{ transform: "scale(2) translateY(-1px)" }}
                    />
                  </span>
                  Back
                </button>
              )}
              {state.loading ? (
                <button className="app-button" disabled>
                  {state.formStage === "SECTION_A" ? "Next" : "Submit"}
                </button>
              ) : (
                <button
                  className="app-button"
                  onClick={(e) => {
                    if (state.formStage === "SECTION_A") {
                      if (validateSectionA()) {
                        setState((ps) => ({
                          ...ps,
                          formStage: "SECTION_B",
                        }));
                      } else {
                        setTimeout(() => {
                          document
                            .getElementsByClassName("invalid")
                            .item(0)
                            ?.parentElement?.scrollIntoView({
                              behavior: "smooth",
                            });
                        }, 100);
                      }
                    } else {
                      if (validateAllData()) setShow(true);
                    }
                  }}
                >
                  {state.formStage === "SECTION_A" ? (
                    <>
                      Next
                      <span className="ml-2">
                        <MdNavigateNext
                          style={{ transform: "scale(2) translateY(-1px)" }}
                        />
                      </span>
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              )}
            </FormGroup>
          </form>
        </Col>
      </Row>
      <Guidelines
        country={Country.BOSNIA}
        show={state.showGuidelines}
        onHide={() => setState({ ...state, showGuidelines: false })}
      />
      <Modal centered show={show} onHide={() => {}}>
        <Modal.Body style={{ padding: "40px", paddingBottom: "10px" }}>
          <FormGroup>
            <h5>Are you sure you want to submit the application?</h5>
            <p className="text-justify">
              Once you submit the application, you will not be able to make any
              more changes.
            </p>
          </FormGroup>
          {state.loading && (
            <FormGroup className="mt-2" style={{ marginBottom: "30px" }}>
              <BarLoader
                height={4}
                width={"100%"}
                color={"#00629b"}
                loading={state.loading}
              />
            </FormGroup>
          )}

          <FormGroup className="text-right">
            {!state.loading && (
              <>
                <button
                  className="app-button mr-2"
                  onClick={() => {
                    setShow(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="app-button"
                  onClick={() => {
                    if (validateAllData()) submitForm();
                  }}
                >
                  Submit
                </button>
              </>
            )}
          </FormGroup>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ApplicationFormBosnia;
